<template>
    <div>
        <DialogoCUDOriginal titulo="Verificá la fecha del CUD"
            msg="En caso de ser una renovación, ingresá la fecha del certificado original y adjuntá el mismo."
            msgAceptar="ADJUNTAR CUD ORIGINAL" msgCancelar="SALIR" ref="dialogoCUD" />
        <v-card flat>
            <ValidationObserver ref="obs" v-slot="{ invalid }">
                <v-form name="formDiscapacidad" @submit.prevent="guardar">
                    <v-row class="mx-1 ">
                        <v-col cols="12" md="12">
                            <div class="font-weight-bold text-body-1 black--text text-uppercase">
                                Régimen especial de discapacidad
                            </div>
                        </v-col>
                        <v-col cols="12" md="12">
                            <div class="font-weight-regular text-body-1 black--text mb-5">
                                Tendrán derecho a solicitar el <b class="primary--text ">Régimen por
                                    Discapacidad</b>
                                aquellos/as afiliados/as
                                que, al
                                momento de la matriculación, presenten una discapacidad permanente y estable del 33% o
                                más.
                                La discapacidad deberá acreditarse mediante la presentación del <b
                                    class="primary--text ">Certificado Único de
                                    Discapacidad (CUD)</b>.<br>
                                La discapacidad declarada será comprobada por una junta médica, que estará integrada
                                por
                                médicos designados por la Caja.
                            </div>
                        </v-col>
                        <v-col cols="12" md="12" class="mb-3">
                            <ValidationProvider :rules="{
                                required: true,
                                rangoFechasAnterior: { fechaDada: datosProfesionales.fecmat, customMessage: 'La fecha de origen de la discapacidad debe ser anterior a la fecha de matriculación' },
                            }" v-slot="{ errors }" ref="fecdiscProvider">
                                <v-text-field v-model="fecdiscFormatted" dense readonly
                                    label="Fecha de orígen de la discapacidad:" append-icon="mdi-calendar"
                                    @click="menuFecdisc = true" @click:append="menuFecdisc = true"
                                    :error-messages="errors"></v-text-field>
                                <v-dialog v-model="menuFecdisc" width="290px">
                                    <v-date-picker v-model="dataSelected.fecdisc" no-title locale="es-AR"
                                        :max="hoyISO" scrollable @input="onPickFecdisc"></v-date-picker>
                                </v-dialog>
                            </ValidationProvider>
                        </v-col>
                        <v-col cols="12" md="12">
                            <ValidationProvider :rules="{
                                required: true, rangoFechasAnterior: original ? false : {
                                    fechaDada: datosProfesionales.fecmat,
                                    customMessage: 'Verificá la fecha del CUD original'
                                }
                            }" v-slot="{ errors }" ref="feccudProvider">
                                <v-text-field v-model="feccudFormatted" dense readonly
                                    :label="(original) ? 'Fecha de CUD original:' : 'Fecha de CUD'"
                                    append-icon="mdi-calendar" @click="menuFeccud = true"
                                    @click:append="menuFeccud = true" :error-messages="errors"></v-text-field>
                                <v-dialog v-model="menuFeccud" width="290px">
                                    <v-date-picker v-model="dataSelected.feccud" no-title locale="es-AR"
                                        :max="hoyISO" scrollable @input="onPickFeccud"></v-date-picker>
                                </v-dialog>
                            </ValidationProvider>
                        </v-col>
                    </v-row>
                    <v-row class="ma-5">
                        <v-divider></v-divider>
                    </v-row>
                    <div v-if="original" class="px-2 pb-5">
                        <v-card-text class="font-weight-bold text-body-1 black--text ">
                            DOCUMENTACIÓN REQUERIDA:
                        </v-card-text>
                        <v-row class="d-flex justify-start mb-8">
                            <InputButtonArchivo op="certDisc" @fileSelected="handleFileSelected" label="CUD Original" />
                        </v-row>
                    </div>
                    <div class="d-flex justify-space-between form-footer" @click="forzarValidacion">
                        <v-btn color="secondary" outlined elevation="0" @click="volver" class="pa-5">
                            <v-icon class="mr-2">mdi-chevron-left</v-icon>atras
                        </v-btn>
                        <!-- :disabled="invalid || !formValid" -->
                        <v-btn color="primary" elevation="0" :disabled="invalid || !formValid" type="submit"
                            class="pa-5">
                            <v-icon class="mr-2">mdi-chevron-right</v-icon>siguiente
                        </v-btn>
                    </div>
                </v-form>
            </ValidationObserver>
        </v-card>
    </div>
</template>

<script>

import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { mapActions, mapGetters } from 'vuex';
import DialogoCUDOriginal from '@/components/dialogos/DialogoCUDOriginal.vue';
import InputButtonArchivo from '@/components/inputs/InputButtonArchivo.vue';
export default {
    name: "formDiscapacidad",

    mounted() {
    },
    components: {
        ValidationObserver,
        InputButtonArchivo,
        ValidationProvider,
        DialogoCUDOriginal,
    },

    data() {
        return {
            dataSelected: {
                fecdisc: '',
                feccud: '',
            },
            original: false,
            formValid: false,
            menuFecdisc: false,
            menuFeccud: false,

        }
    },

    watch: {
        'dataSelected.feccud'() {
            const p = this.$refs.feccudProvider;
            if (!p) return;
            // Campo readonly: sincronizamos el valor actual antes de validar (vee-validate
            // no lo capta solo porque el input no dispara el evento 'input').
            if (typeof p.syncValue === 'function') p.syncValue(this.feccudFormatted);
            p.validate(this.feccudFormatted).then(() => {
                if (p.errors[0] == 'Verificá la fecha del CUD original') {
                    this.$refs.dialogoCUD.abrirDialogo().then(result => {
                        if (!result) {
                            this.dataSelected.feccud = ''
                        } else {
                            this.original = true
                        }
                    })
                } else {
                    this.formValid = true
                }
            });
        }
    },

    methods: {
        ...mapActions('preafiliacion', ['guardarDatosRegimenDiscapacidad', 'addFilesPre']),

        volver() {
            this.original = false
            this.formValid = false
            this.addFilesPre({ op: 'certDisc', files: '' })
            this.$emit('atras')
        },
        handleFileSelected() {
            if (this.original) (this.certDisc.length == 2) ? this.formValid = true : this.formValid = false
        },
        // ISO 'yyyy-mm-dd' -> 'dd/mm/yyyy' (formato fijo, independiente del SO/navegador)
        formatFecha(iso) {
            if (!iso) return '';
            const [y, m, d] = iso.split('-');
            return `${d}/${m}/${y}`;
        },
        // El campo es readonly (la fecha se elige por el calendario): sincronizamos el valor
        // al provider y lo validamos a mano, porque no dispara el evento input.
        revalidarProvider(refName, valor) {
            const p = this.$refs[refName];
            if (!p) return;
            if (typeof p.syncValue === 'function') p.syncValue(valor);
            p.validate(valor);
        },
        onPickFecdisc() {
            this.menuFecdisc = false;
            this.$nextTick(() => this.revalidarProvider('fecdiscProvider', this.fecdiscFormatted));
        },
        onPickFeccud() {
            // El watcher de dataSelected.feccud maneja la validacion + el dialogo del CUD original
            this.menuFeccud = false;
        },
        forzarValidacion() {
            this.$refs.obs.validate().then(result => {
                if (!result) {
                    const firstErrorElement = this.$el.querySelector('.v-messages__message');
                    if (firstErrorElement) firstErrorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
            });
        },
        guardar() {
            this.$refs.obs.validate().then(result => {
                if (result) {
                    this.guardarDatosRegimenDiscapacidad(this.dataSelected)
                    this.$emit('siguiente')
                    // this.getOpcionNivel()
                } else {
                    this.showSnack({
                        message: 'Formulario inválido, no se puede enviar la petición',
                        type: '400'
                    })
                }
            })

        }
    },
    computed: {
        ...mapGetters('preafiliacion', ['certDisc', 'datosProfesionales']),
        // Fecha maxima seleccionable (hoy): estas fechas siempre son pasadas
        hoyISO() {
            return new Date().toISOString().slice(0, 10);
        },
        // Muestran la fecha SIEMPRE como dd/mm/yyyy sin depender del formato regional.
        // El valor real (dataSelected.*) sigue en ISO; el campo es readonly (se elige por
        // calendario), por eso el setter no se usa.
        fecdiscFormatted: {
            get() { return this.formatFecha(this.dataSelected.fecdisc); },
            set() { },
        },
        feccudFormatted: {
            get() { return this.formatFecha(this.dataSelected.feccud); },
            set() { },
        },
    }
}
</script>